import { Button } from "@material-ui/core";
import React from "react";
import "./Card.css";

function Card({ src, title, url }) {
  return (
    <div className="card">
      <img className="card__img" src={src} alt="" />
      <div className="card__info">
        <h4 className="card__title">{title}</h4>
      </div>
      <Button
        style={{
          backgroundColor: "#baf4ff",
          color: "#000000",
        }}
        size="small"
        fullWidth
        variant="contained"
        onClick={() => window.open(`${url}`)}
      >
        Open Live Project
      </Button>
    </div>
  );
}

export default Card;
